import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './lib/axiosInit';
import 'dayjs/locale/zh-cn'
import 'mobx-react-lite/batchingForReactDom'

ReactDOM.render(<App />, document.getElementById('root'));
